import React from 'react';
// import React, { useCallback, useEffect, useState } from 'react';
// import { useHistory } from 'react-router-dom';
// import { ChevronRight } from '@mui/icons-material';

import { ROUTES } from '../../routes';
// import { fetchPosts, PostItem, FetchPostsResult } from '../../apis/news';

import {
  Breadcrumb,
  BreadcrumbItem,
} from '../../components/breadcrumb/breadcrumb';
// import { SecondaryBanners } from '../secondary-banners/secondary-banners';
// import { Pagination } from '../../components';

import styles from './news-page.module.css';

const BANNER_DESKTOP = `${process.env.PUBLIC_URL}/images/banner/banner-periodo-eleitoral.png`;
const BANNER_MOBILE = `${process.env.PUBLIC_URL}/images/banner/banner-periodo-eleitoral-mobile.png`;
const BANNER_ALT =
  'Atenção: no período de 04 de julho até o término das eleições, este site terá atualizações permitidas pela legislação eleitoral, com foco em serviços públicos. As publicações em nossas redes sociais ficarão suspensas no período.';

// const NEWS_IMAGE_PLACEHOLDER = `data:image/svg+xml,${encodeURIComponent(
//   `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300">
//     <rect width="400" height="300" fill="#e8ebf2"/>
//     <g fill="none" stroke="#a9b2c9" stroke-width="8" stroke-linejoin="round" stroke-linecap="round">
//       <rect x="130" y="110" width="140" height="100" rx="8"/>
//       <circle cx="165" cy="145" r="12"/>
//       <path d="M138 200l35-35 25 25 30-30 34 34"/>
//     </g>
//     <text x="200" y="248" font-family="Montserrat, sans-serif" font-size="20" font-weight="600" fill="#a9b2c9" text-anchor="middle">Sem imagem</text>
//   </svg>`
// )}`;

// const NewsImage: React.FC<{ src?: string; alt: string }> = ({ src, alt }) => (
//   <img
//     src={src || NEWS_IMAGE_PLACEHOLDER}
//     alt={alt}
//     onError={(e) => {
//       e.currentTarget.src = NEWS_IMAGE_PLACEHOLDER;
//     }}
//   />
// );

export const NewsPage: React.FC = () => {
  // const [newsData, setNewsData] = useState<PostItem[]>([]);
  // const [totalCount, setTotalCount] = useState(0);
  // const [page, setPage] = useState(1);
  // const navigate = useHistory();
  // const itemsPerPage = 11;

  // useEffect(() => {
  //   fetchPosts(page - 1, itemsPerPage).then(
  //     ({ items, total }: FetchPostsResult) => {
  //       setNewsData(items);
  //       setTotalCount(total);
  //     }
  //   );
  // }, [page]);

  // const totalPages = Math.max(1, Math.ceil(totalCount / itemsPerPage));

  const breadcrumbs: BreadcrumbItem[] = [
    { name: 'Notícias', path: ROUTES.NEWS_PAGE },

  ];

  // const handleChange = (_: React.ChangeEvent<unknown>, value: number) => {
  //   setPage(value);
  // };

  // const goToNewPage = useCallback(
  //   (id: string) => {
  //     navigate.push(ROUTES.DYNAMIC_NEWS_PAGE.replace(':newsType', id));
  //   },
  //   [navigate]
  // );

  // const mainNews = newsData[0];
  // const sideNews = newsData.slice(1, 4);
  // const middleNews = newsData.slice(4, 7);
  // const bottomMainNews = newsData[7];
  // const bottomSideNews = newsData.slice(8, 11);

  return (
    <section className={styles.newsPage}>
      <div className={styles.headerContainer}>
        <Breadcrumb items={breadcrumbs} aria-label="breadcrumb" />
        <div className={styles.headerTitle}>Notícias</div>
      </div>

      <div className={styles.electionBannerContainer}>
        <picture>
          <source media="(max-width: 768px)" srcSet={BANNER_MOBILE} />
          <img
            src={BANNER_DESKTOP}
            alt={BANNER_ALT}
            className={styles.electionBanner}
          />
        </picture>
      </div>

      {/* Conteúdo de notícias desabilitado durante o período eleitoral. */}
      {/* {mainNews && (
        <div className={styles.topGridContainer}>
          <div
            onClick={() => goToNewPage(mainNews.id)}
            className={styles.mainNews}
          >
            <NewsImage src={mainNews.image} alt={mainNews.title} />
            <div className={styles.overlay}>
              <div className={styles.mainNewsTheme}>
                {`${mainNews.theme} | Destaque`}
              </div>
              <div className={styles.mainNewsTitle}>{mainNews.title}</div>
            </div>
          </div>

          <div className={styles.sideNews}>
            {sideNews.map((news) => (
              <div
                onClick={() => goToNewPage(news.id)}
                key={news.id}
                className={styles.sideNewsItem}
              >
                <NewsImage src={news.image} alt={news.title} />
                <div className={styles.sideNewsOverlay}>
                  <div className={styles.newsTheme}>
                    <span>{news.theme}</span>
                    <span> há {news.time}</span>
                  </div>
                  <div className={styles.newsTitle}>{news.title}</div>
                  <div className={styles.goToNews}>
                    Acessar completa <ChevronRight />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )} */}

      {/* <div className={styles.middleRow}>
        {middleNews.map((news) => (
          <div
            onClick={() => goToNewPage(news.id)}
            key={news.id}
            className={styles.middleNewsItem}
          >
            <NewsImage src={news.image} alt={news.title} />
            <div className={styles.middleOverlay}>
              <div className={styles.newsTheme}>
                <span>{news.theme}</span>
                <span> há {news.time}</span>
              </div>
              <div className={styles.newsTitle}>{news.title}</div>
              <div className={styles.goToNews}>
                Acessar completa <ChevronRight />
              </div>
            </div>
          </div>
        ))}
      </div> */}
      {/* <div className={styles.secondaryBanners}>
        <SecondaryBanners disableBackground />
      </div> */}

      {/* {bottomMainNews && (
        <div className={styles.bottomGridContainer}>
          <div
            className={styles.mainNews}
            onClick={() => goToNewPage(bottomMainNews.id)}
          >
            <NewsImage src={bottomMainNews.image} alt={bottomMainNews.title} />
            <div className={styles.overlay}>
              <div className={styles.mainNewsTheme}>
                {`${bottomMainNews.theme} | Destaque`}
              </div>
              <div className={styles.mainNewsTitle}>{bottomMainNews.title}</div>
            </div>
          </div>

          <div className={styles.sideNews}>
            {bottomSideNews.map((news) => (
              <div
                onClick={() => goToNewPage(news.id)}
                key={news.id}
                className={styles.sideNewsItem}
              >
                <NewsImage src={news.image} alt={news.title} />
                <div className={styles.sideNewsOverlay}>
                  <div className={styles.newsTheme}>
                    <span>{news.theme}</span>
                    <span> há {news.time}</span>
                  </div>
                  <div className={styles.newsTitle}>{news.title}</div>
                  <div className={styles.goToNews}>
                    Acessar completa <ChevronRight />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )} */}

      {/* <div className={styles.paginationContainer}>
        <Pagination count={totalPages} onChange={handleChange} page={page} />
      </div> */}
    </section>
  );
};
